import { PAYMENT_CODE, fieldNamesAndLabels } from "../../../infrastructure/utils/formUtils";

const deepMerge = (target, source) => {
    for (const key of Object.keys(source)) {
        if (
            source[key] instanceof Object &&
            !Array.isArray(source[key]) &&
            target[key] instanceof Object
        ) {
            Object.assign(source[key], deepMerge(target[key] || {}, source[key]));
        }
    }
    return { ...target, ...source };
};

const formValidator = (formData, fieldNamesAndLabels, additionalRules = {}) => {
    const newErrors = {};

    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    const validatePhoneNumber = (pNumber) => {
        const regex = /^(?:\+420|00420)?\s?[1-9][0-9]{2}\s?[0-9]{3}\s?[0-9]{3}$/;
        return regex.test(pNumber);
    };

    const rules = {
        subscriptionType: {
            required: true,
            message: 'Vyplňte ' + fieldNamesAndLabels.subscriptionType?.label,
        },
        email: {
            required: true,
            pattern: emailRegex,
            message: {
                required: 'Vyplňte ' + fieldNamesAndLabels.email?.label,
                invalid: fieldNamesAndLabels.email?.label + ' je nevalidní',
            },
        },
        telephone: {
            required: true,
            custom: validatePhoneNumber,
            message: {
                required: 'Vyplňte ' + fieldNamesAndLabels.telephone?.label,
                invalid: fieldNamesAndLabels.telephone?.label + ' je nevalidní',
            },
        },
        password: {
            required: true,
            custom: (value) => {
                const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W_]{8,}$/;
                return passwordRegex.test(value);
            },
            customDisabled: false, // This flag allows disabling custom checks for this field
            message: {
                required: 'Vyplňte ' + fieldNamesAndLabels.password?.label,
                invalid: fieldNamesAndLabels.password?.label + ' musí obsahovat alespoň 1 malé písmeno, 1 velké písmeno, 1 číslo a mít délku alespoň 8 znaků',
            },
        },
        name: {
            required: true,
            message: 'Vyplňte ' + fieldNamesAndLabels.name?.label,
        },
        surname: {
            required: true,
            message: 'Vyplňte ' + fieldNamesAndLabels.surname?.label,
        },
        street: {
            required: true,
            message: 'Vyplňte ' + fieldNamesAndLabels.street?.label,
        },
        city: {
            required: true,
            message: 'Vyplňte ' + fieldNamesAndLabels.city?.label,
        },
        zipCode: {
            required: true,
            message: 'Vyplňte ' + fieldNamesAndLabels.zipCode?.label,
        },
        paymentType: {
            required: true,
            message: 'Vyplňte ' + fieldNamesAndLabels.paymentType?.label,
        },
        subscriptionActivationCode: {
            required: formData.paymentType === PAYMENT_CODE,
            message: 'Vyplňte ' + fieldNamesAndLabels.subscriptionActivationCode?.label,
        },
        streetDelivery: {
            required: formData.deliveryDifferentAddress,
            message:
                'Vyplňte ' +
                fieldNamesAndLabels.streetDelivery?.label +
                ' (doručovací)',
        },
        cityDelivery: {
            required: formData.deliveryDifferentAddress,
            message:
                'Vyplňte ' +
                fieldNamesAndLabels.cityDelivery?.label +
                ' (doručovací)',
        },
        zipCodeDelivery: {
            required: formData.deliveryDifferentAddress,
            message:
                'Vyplňte ' +
                fieldNamesAndLabels.zipCodeDelivery?.label +
                ' (doručovací)',
        },
        companyName: {
            required: formData.asCompany,
            message: 'Vyplňte ' + fieldNamesAndLabels.companyName?.label,
        },
        ico: {
            required: formData.asCompany,
            message: 'Vyplňte ' + fieldNamesAndLabels.ico?.label,
        },
        antiSpam: {
            required: true,
            message: 'Vyplňte ' + fieldNamesAndLabels.antiSpam?.label,
        },
    };

    // Merge additional rules
    // Object.assign(rules, additionalRules);
    const mergedRules = deepMerge(rules, additionalRules);

    Object.keys(mergedRules).forEach((field) => {
        if (formData.hasOwnProperty(field)) {
            const rule = mergedRules[field];
            const value = formData[field];

            // if(field == 'password'){
            //     console.log(mergedRules);
            //     console.log(mergedRules[field]);
            //     console.log(field + ":" + rule.required);
            //     console.log(field + ":" + value);
            // }

            if (rule.required && !value) {
                newErrors[field] = rule.message.required || rule.message;
            } else if (rule.pattern && !rule.pattern.test(value)) {
                newErrors[field] = rule.message.invalid || rule.message;
            } else if (rule.custom && !rule.customDisabled && !rule.custom(value)) {
                newErrors[field] = rule.message.invalid || rule.message;
            }
        }
    });

    // Return errors object and validity
    return {
        isValid: Object.keys(newErrors).length === 0,
        validationErrors: newErrors,
    };
};

// Export the function for reuse
export default formValidator;
